// ABOUTME: The job types started by actions of the application (imports, exports, duplications…) rather
// ABOUTME: than from the manual launch: the type filter of the job list offers them besides the `jobList`.

/**
 * Types launched by a button, a dialog or a save elsewhere in the application, or by the server on
 * such an action. They are not in the company's `jobList` (which lists what can be launched by
 * hand), yet they fill most of the job list, so the type filter must offer them too.
 */
export const ACTION_JOB_TYPES: readonly string[] = [
    // Hierarchy upload, export and history download.
    'import',
    'ExportXlsx',
    'ExportHistory',
    // The xlsx export of the offers and orders lists.
    'cpq-list-export',
    // Node, short list and hierarchy duplication.
    'duplicate-node',
    'duplicate-hierarchy',
    // Saving the permissions of a large subtree.
    'propagate-node-permissions',
    // Bulk change: the scan builds the preview, the apply writes it; a saved rule runs both.
    'find-replace-scan',
    'find-replace-apply',
    'bulk-change-rule',
    // Publishing a hierarchy, the completeness widget's translation, the Configit import.
    'publish-hierarchy',
    'auto-translate-hierarchy',
    'configitImport',
    // Settings: visibility alignment of existing data.
    'align-dealership-sharing',
    'align-market-stamps',
    // Settings: migration of the legacy image/file fields onto the MEDIA hierarchy.
    'migrateLegacyMediaFields',
    // Agents: one job per agent run.
    'agent-runner',
    // CGT: price alignment, family publish/close/reopen, transversal GL export.
    'AlignPrices',
    'publish-family',
    'close-family',
    'reopen-family',
    'export-trasversal-gls',
];

const actionJobTypes = new Set(ACTION_JOB_TYPES);

export const isActionJobType = (type: string) => actionJobTypes.has(type);
